/** @jsx jsx */
import { memo } from 'react';
import { ClassNames, jsx } from '@emotion/core';
import { contentCSS, contentCSSWrapper, descriptionCSS, elemAfterCSS, elemBeforeCSS, truncateCSS, wrapDescriptionCSS, wrapTextCSS } from '../styles/menu-item/base-item';

const defaultRender = (Component, props) => jsx(Component, props);
/**
 * __Base item__
 *
 * A base item should be composed for all item experiences.
 */


const BaseItem = /*#__PURE__*/memo(({
  children,
  description,
  iconAfter,
  iconBefore,
  overrides,
  shouldTitleWrap = false,
  shouldDescriptionWrap = false
}) => {
  const renderTitle = overrides && overrides.Title && overrides.Title.render || defaultRender;
  return (// eslint-disable-next-line @repo/internal/react/consistent-css-prop-usage
    jsx("div", {
      css: contentCSSWrapper
    }, iconBefore && // eslint-disable-next-line @repo/internal/react/consistent-css-prop-usage
    jsx("span", {
      "data-item-elem-before": true,
      css: elemBeforeCSS
    }, iconBefore), children && // eslint-disable-next-line @repo/internal/react/consistent-css-prop-usage
    jsx("span", {
      css: contentCSS
    }, jsx(ClassNames, null, ({
      css
    }) => renderTitle('span', {
      children,
      className: css(shouldTitleWrap ? wrapTextCSS : truncateCSS),
      'data-item-title': true
    })), description && jsx("span", {
      "data-item-description": true,
      css: // eslint-disable-next-line @repo/internal/react/consistent-css-prop-usage
      shouldDescriptionWrap ? wrapDescriptionCSS : descriptionCSS
    }, description)), iconAfter && // eslint-disable-next-line @repo/internal/react/consistent-css-prop-usage
    jsx("span", {
      "data-item-elem-after": true,
      css: elemAfterCSS
    }, iconAfter))
  );
});
export default BaseItem;